module.exports = __webpack_public_path__ + "static/img/14000452.85b57acf.png";